/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'Feedback'>;
const hooks = useModelQueries(schema, 'Feedback');

export const useAggregateFeedback: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountFeedback: Hooks['useCount'] = hooks.useCount;
export const useCreateFeedback: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyFeedback: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnFeedback: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteFeedback: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyFeedback: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsFeedback: Hooks['useExists'] = hooks.useExists;
export const useFindFirstFeedback: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyFeedback: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueFeedback: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByFeedback: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyFeedback: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateFeedback: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountFeedback: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstFeedback: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyFeedback: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueFeedback: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByFeedback: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyFeedback: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateFeedback: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyFeedback: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnFeedback: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertFeedback: Hooks['useUpsert'] = hooks.useUpsert;
